"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sparta = void 0;
exports.sparta = {
    red100: "#E8344E",
    red75: "#FF6C7A",
    red50: "#FF9EA9",
    red25: "#FFD0DA",
    red15: "#FFF1F4",
    red10: "#FFF6F8",
    blue100: "#0085FF",
    blue10: "#EDF3FF",
    yellow100: "#FFD600",
};
//# sourceMappingURL=sparta.js.map